var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"shade",class:{ hide: _vm.ignore }})])
}
var staticRenderFns = []

export { render, staticRenderFns }